import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const GuessTheMoveLeaderboardForm = () => {
    return (
        <div className="flex-grow space-y-6">
            <Card>
                <CardHeader>
                    <CardTitle>Guess The Move Leaderboard</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="text-muted-foreground text-sm">
                        This block displays a leaderboard showing the top 5 players in the Guess The
                        Move game. If placed within a tournament container, it will show the top 5
                        for that tournament. Otherwise, it will show the overall top 5 for the last
                        7 days.
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};
